import type { Mypage, YearlyRanking } from "../../types/swagger";
import {
  buildMockEventName,
  loginMemberProfile,
  mockSeasonEvents,
  rankingEventGroup,
  type MockSeasonEvent,
} from "./rankingSeason";

/** イベントの results からログインユーザーの match_results を生成する */
const buildMatchResults = (event: MockSeasonEvent) => {
  const myResult = event.results.find(
    (e) => e.name === loginMemberProfile.name,
  );
  if (!myResult) return [];

  return event.results
    .filter((e) => e.name !== loginMemberProfile.name)
    .map((opponent) => {
      const iWon = myResult.singlesRank < opponent.singlesRank;
      return {
        opponent_dartslive_card_name: opponent.name,
        opponent_login_id: opponent.login_id,
        my_win_count: iWon ? 2 : 0,
        opponent_win_count: iWon ? 0 : 2,
        rank: myResult.singlesRank,
      };
    });
};

const memberProfiles = [
  { name: "Sho Aoki", is_login_member: false },
  { name: loginMemberProfile.name, is_login_member: true },
  { name: "野澤 哲也", is_login_member: false },
  { name: "Max Verstappen", is_login_member: false },
];

const rankingHistoryEvents = mockSeasonEvents.filter((event) => event.results.length > 0);

const toMemberEventPoints = (
  memberName: string,
): YearlyRanking["event_acquired_points"] =>
  rankingHistoryEvents.flatMap((event) => {
    const result = event.results.find((entry) => entry.name === memberName);
    if (!result) {
      return [];
    }

    return [
      {
        event_name: buildMockEventName(event),
        point: result.point,
        date: event.datetime,
      },
    ];
  });

export const mockYearlyRankings: YearlyRanking[] = memberProfiles
  .map((member) => {
    const event_acquired_points = toMemberEventPoints(member.name);

    return {
      rank: 0,
      name: member.name,
      point: event_acquired_points.reduce((sum, event) => sum + event.point, 0),
      is_login_member: member.is_login_member,
      event_acquired_points,
    };
  })
  .sort((left, right) => right.point - left.point)
  .map((member, index) => ({
    ...member,
    rank: index + 1,
  }));

const mypageRanking = mockYearlyRankings.find(
  (ranking) => ranking.name === loginMemberProfile.name,
);

export const mockMypage: Mypage = {
  login_id: loginMemberProfile.login_id,
  dartslive_card_name: loginMemberProfile.dartslive_card_name,
  event_group: rankingEventGroup,
  yearly_rank: mypageRanking?.rank ?? 0,
  yearly_point: mypageRanking?.point ?? 0,
  participated_events: [
    {
      event_group: rankingEventGroup,
      events: rankingHistoryEvents
        .flatMap((event) => {
          const result = event.results.find(
            (entry) => entry.name === loginMemberProfile.name,
          );
          if (!result) {
            return [];
          }

          return [
            {
              event_name: buildMockEventName(event),
              event_date: event.datetime,
              singles_rank: result.singlesRank,
              singles_point: result.point,
              match_results: buildMatchResults(event),
            },
          ];
        })
        .sort(
          (left, right) =>
            new Date(right.event_date).getTime() -
            new Date(left.event_date).getTime(),
        ),
    },
  ],
};
